@if(!priorMcId || priorMcId == 'na'){
<apt-template-nested-state state="info" title="Invalid Policy">
  <ng-container message>
    <p>
      <ng-container *ngIf="priorMcId == 'na'">
        <p>No policy id was provided. To access the cyber application, please follow a valid link.</p>
      </ng-container>
    </p>
  </ng-container>
</apt-template-nested-state>

} @else {
<div
  fxLayout="column"
  fxFlexFill
  [ngStyle]="{ height: '68vh', overflow: 'hidden' }"
  [ngStyle.xs]="{ height: 'auto', overflow: 'auto' }"
  style="width: 100%"
  *ngIf="policyCheckComplete && !canShowCyber"
>
  <apt-template-nested-state state="error" title="Policy Time Out Error">
    <ng-container message>
      <p>{{ policyTimeoutMessage }}</p>
    </ng-container>
  </apt-template-nested-state>
</div>
<div *ngIf="canShowCyber" class="cyber-container">
  <app-cyber-quote></app-cyber-quote>

  <apt-h1 class="cyber-title">Cyber Application</apt-h1>

  <form [formGroup]="cyberForm" (ngSubmit)="submitCyberForm()" aptForm>
    <div class="question-wr">
      <apt-text-label
        >Does the applicant enforce Multi-Factor Authentication (MFA) for Email and Remote Access?</apt-text-label
      >

      <div class="radio-wr">
        <apt-radio label="Yes">
          <input id="yesRadioQ1" type="radio" value="Y" formControlName="q1_radio" name="q1_radio" />
        </apt-radio>

        <apt-radio label="No">
          <input id="noRadioQ1" type="radio" value="N" formControlName="q1_radio" name="q1_radio" />
        </apt-radio>
      </div>
    </div>

    <div class="question-wr">
      <apt-text-label>
        <div>
          Does the applicant have access to or store or transmit more than 50,000 of the following sensitive records?
        </div>
        <ul style="font-weight: 400; margin-top: 0">
          <li>Personal Information (Name, DOB, Address, etc.)</li>
          <li>Medical (PHI)</li>
          <li>Social Security or National Id</li>
          <li>Other Sensitive Data</li>
          <li>Credit/Debit Cards</li>
          <li>Financial/Banking</li>
          <li>Other Financial Data</li>
        </ul>
      </apt-text-label>

      <div class="radio-wr">
        <apt-radio label="Yes">
          <input id="yesRadioQ2" type="radio" value="Y" formControlName="q2_radio" name="q2_radio" />
        </apt-radio>

        <apt-radio label="No">
          <input id="noRadioQ2" type="radio" value="N" formControlName="q2_radio" name="q2_radio" />
        </apt-radio>
      </div>
    </div>

    <div class="question-wr">
      <apt-text-label
        >During the past five years, has the applicant experienced any incidents, occurrences, claims, or losses related
        to (1) a network security breach, (2) a violation of privacy, or (3) content or material disseminated by or on
        behalf of the Applicant or does the Applicant have knowledge of a situation or circumstance which might
        otherwise result in a claim against the Applicant with regard to the insurance sought?</apt-text-label
      >

      <div class="radio-wr">
        <apt-radio label="Yes">
          <input id="yesRadioQ3" type="radio" value="Y" formControlName="q3_radio" name="q3_radio" />
        </apt-radio>

        <apt-radio label="No">
          <input id="noRadioQ3" type="radio" value="N" formControlName="q3_radio" name="q3_radio" />
        </apt-radio>
      </div>
    </div>
    <!-- <div class="question-wr">
      <apt-text-label
        >Does the Applicant perform any additional Professional Services other than the Professional Service already
        selected?
      </apt-text-label>

      <div class="radio-wr">
        <apt-radio label="Yes">
          <input id="yesRadioQ4" type="radio" value="Y" formControlName="q4_radio" name="q4_radio" />
        </apt-radio>

        <apt-radio label="No">
          <input id="noRadioQ4" type="radio" value="N" formControlName="q4_radio" name="q4_radio" />
        </apt-radio>
      </div>
    </div> -->

    <apt-button-footer>
      <ng-container buttonFooterRight>
        <apt-button type="button" (click)="cancelCyberForm()" [disabled]="submitting"> Cancel </apt-button>
        <apt-button
          [primary]="true"
          type="submit"
          [disabled]="submitting || !cyberForm.valid"
          [aptTooltip]="!cyberForm.valid ? 'Please complete the above selections.' : ''"
          tooltipPlacement="top"
          tooltipMaxWidth="matchElm"
        >
          {{ submitting ? 'Submitting...' : 'Submit' }}
        </apt-button>
      </ng-container>
    </apt-button-footer>
  </form>
</div>

<apt-dialog title="" modal="true" [(open)]="submitting" width="670px" [showCloseX]="false">
  <ng-container dialogBody>
    <apt-waiter
      [evaluate]="cyberFinished"
      [title]="'Processing Cyber Application'"
      [rollingText]="cyberMessages"
      [rollingWait]="5000"
      [repeat]="true"
      [timeout]="0"
      [error]="cyberError"
    ></apt-waiter>
    <!-- [contactInfo]="cyberContactInfo" -->
  </ng-container>
</apt-dialog>

<apt-dialog [title]="postCyberTitle" modal="true" [(open)]="postCyberRequest" [showCloseX]="true">
  <ng-container dialogBody>
    <p>{{ postCyberMessage }}</p>
  </ng-container>
</apt-dialog>

<apt-dialog [title]="cyberStatusTitle" modal="true" [(open)]="showCyberStatusDialog" [showCloseX]="false">
  <ng-container dialogBody>
    <p>{{ cyberStatusMessage }}</p>
  </ng-container>
</apt-dialog>

<apt-dialog title="" modal="true" [(open)]="showCancelDialog" [showCloseX]="true">
  <ng-container dialogBody>
    <apt-h2 class="cyber-cancel-title">Cancel Confirmation</apt-h2>
    <p>Do you want to cancel the Cyber Application?</p>
  </ng-container>
  <ng-container dialogFooter>
    <div class="cyber-cancel-actions">
      <apt-button-footer>
        <ng-container buttonFooterRight>
          <apt-button class="cancel-yes" secondary="default" (click)="confirmCancel()">Yes, Cancel</apt-button>
        </ng-container>
        <ng-container buttonFooterRight>
          <apt-button class="cancel-no" [primary]="true" (click)="showCancelDialog = false">No</apt-button>
        </ng-container>
      </apt-button-footer>
    </div>
  </ng-container>
</apt-dialog>

}
